import { combineReducers } from 'redux';

import auth from './auth/reducers';
import user from './user/reducers';
import person from './person/reducers';

export default combineReducers({
  auth,
  user,
  person,
})